import { useAtomValue } from "@effect/atom-react";
import { SearchIcon } from "lucide-react";

import { openCommandPalette } from "~/commandPaletteBus";
import { shortcutLabelForCommand } from "~/keybindings";
import { primaryServerKeybindingsAtom } from "~/state/server";
import { Button } from "~/components/ui/button";
import { Tooltip, TooltipPopup, TooltipTrigger } from "~/components/ui/tooltip";

/**
 * The centered titlebar search door opens the existing command overlay.
 * Its shortcut follows the person's keybindings; narrow windows keep the
 * accessible icon door. Opening the overlay never changes the current place.
 */
export function DeskSearchDoor() {
  const keybindings = useAtomValue(primaryServerKeybindingsAtom);
  const shortcut = shortcutLabelForCommand(keybindings, "commandPalette.toggle");
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            aria-label="Search & commands"
            className="ncl-ticker-glass h-8 w-[min(360px,42vw)] gap-2 rounded-full px-3 text-xs text-muted-foreground hover:text-foreground max-sm:w-8 max-sm:px-0 [--control-icon-color:currentColor]"
            data-shell-utility="search"
            onClick={() => openCommandPalette()}
            size="sm"
            variant="ghost"
          >
            <span aria-hidden="true" className="flex items-center">
              <SearchIcon className="size-3.5" />
            </span>
            <span className="min-w-0 flex-1 truncate text-left max-sm:hidden">
              Search &amp; commands
            </span>
            {shortcut ? (
              <kbd className="shrink-0 text-[10px] opacity-70 max-md:hidden">{shortcut}</kbd>
            ) : null}
          </Button>
        }
      />
      <TooltipPopup side="bottom">
        Search &amp; commands{shortcut ? ` (${shortcut})` : ""}
      </TooltipPopup>
    </Tooltip>
  );
}
